module.exports = __webpack_public_path__ + "static/media/vegetables.5ce871d4.png";